import { officeHomeAppRouteToPath } from './officeHomeAppRouteToPath';
export var getOfficeHomeAppRouteToPath = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    if (!prefix) {
        return officeHomeAppRouteToPath;
    }
    var prefixedRouteToPath = {};
    for (var key in officeHomeAppRouteToPath) {
        prefixedRouteToPath[key] = "".concat(prefix).concat(officeHomeAppRouteToPath[key]);
    }
    return prefixedRouteToPath;
};
//# sourceMappingURL=getOfficeHomeAppRouteToPath.js.map